<div class="registro">


  <!-- Passo 1: Intro -->
  <section *ngIf="isAtivo(1)" class="card">
    <h3>🎉 Parabéns pelo primeiro passo!</h3>
    <p>Você acaba de iniciar sua jornada rumo à organização, eficiência e resultados.
      O LawServices está aqui para simplificar sua gestão de clientes e processos para te ajudar a alcançar seus objetivos com muito mais clareza e produtividade. 🚀</p>
    <div class="actions">
      <button (click)="avancar()">Continuar</button>
    </div>
  </section>

  <!-- Passo 2: Email -->
  <section *ngIf="isAtivo(2)" class="card">
    <label for="email">Qual é o seu e-mail?</label>
    <input id="email" type="email" [ngModel]="email()" (ngModelChange)="email.set($event); erroEmail.set(null)" placeholder="seu.email@empresa.com" />
    <small *ngIf="erroEmail()" style="color:#c0392b; display:block; margin-top:4px;">{{ erroEmail() }}</small>
    <div class="actions">
      <button (click)="voltar()" [disabled]="verificandoEmail()">Voltar</button>
      <button [disabled]="!podeAvancarEmail || verificandoEmail()" (click)="avancar()">
        {{ verificandoEmail() ? 'Verificando...' : 'Continuar' }}
      </button>
    </div>
  </section>

  <!-- Passo 3: Nome -->
  <section *ngIf="isAtivo(3)" class="card">
    <label for="nome">Qual é o seu nome completo?</label>
    <input class="email-edit" id="nome" type="text" [ngModel]="nome()" (ngModelChange)="nome.set($event)" placeholder="Seu nome completo" />
    <div class="actions">
      <button (click)="voltar()">Voltar</button>
      <button [disabled]="!podeAvancarNome" (click)="avancar()">Continuar</button>
    </div>
  </section>

  <!-- Passo 4: Senha -->
  <section *ngIf="isAtivo(4)" class="card">
    <label for="senha">Agora, defina uma senha segura para sua conta</label>
    <input id="senha" type="password" [ngModel]="senha()" (ngModelChange)="senha.set($event)" placeholder="Digite sua senha" />
    <small>Mínimo de 6 caracteres.</small>
    <div class="actions">
      <button (click)="voltar()">Voltar</button>
      <button [disabled]="!podeAvancarSenha" (click)="avancar()">Continuar</button>
    </div>
  </section>

  <!-- Passo 5: Confirmar Senha -->
  <section *ngIf="isAtivo(5)" class="card">
    <label for="confirmarSenha">Confirme sua senha</label>
    <input id="confirmarSenha" type="password" [ngModel]="confirmarSenha()" (ngModelChange)="confirmarSenha.set($event)" placeholder="Repita sua senha" />
    <small *ngIf="confirmarSenha() && !senhasConferem" style="color:#c0392b;">As senhas não coincidem.</small>
    <div class="actions">
      <button (click)="voltar()">Voltar</button>
      <button [disabled]="!podeAvancarConfirmarSenha" (click)="avancar()">Continuar</button>
    </div>
  </section>

  <!-- Passo 6: CPF/CNPJ -->
  <section *ngIf="isAtivo(6)" class="card">
    <label for="cpf">CPF/CNPJ</label>
    <input id="cpf" type="text" [ngModel]="cpf()" (ngModelChange)="cpf.set($event); erroCpf.set(null)" placeholder="Digite seu CPF ou CNPJ (apenas números)" />
    <small *ngIf="erroCpf()" style="color:#c0392b; display:block; margin-top:4px;">{{ erroCpf() }}</small>
    <small *ngIf="!erroCpf()">Dica: digite apenas números.</small>
    <div class="actions">
      <button (click)="voltar()" [disabled]="verificandoCpf()">Voltar</button>
      <button [disabled]="!podeAvancarCPF || verificandoCpf()" (click)="avancar()">
        {{ verificandoCpf() ? 'Verificando...' : 'Continuar' }}
      </button>
    </div>
  </section>

  <!-- Passo 7: Planos -->
  <section *ngIf="isAtivo(7)" class="card">
    <h3>Selecione um plano</h3>
    <div class="planos">
      <button type="button"
              *ngFor="let p of planos"
              class="plano"
              [class.selecionado]="planoSelecionado() === p.id"
              (click)="selecionarPlano(p.id)">
        <div class="plano-nome">{{ p.nome }}</div>
        <div class="plano-preco">{{ formatPreco(p.preco) }}</div>
      </button>
    </div>
    <div class="actions">
      <button (click)="voltar()" [disabled]="enviando()">Voltar</button>
      <button [disabled]="!podeAvancarPlano || enviando()" (click)="avancar()">
        {{ enviando() ? 'Enviando...' : 'Assinar' }}
      </button>
    </div>
    <div *ngIf="erroEnvio()" style="color:#e74c3c; margin-top:8px;">
      {{ erroEnvio() }}
    </div>
  </section>

  <!-- Passo 7.5: Pagamento PIX -->
  <section *ngIf="isAtivo(7.5)" class="card pix-container">
    <h3>Pagamento PIX</h3>

    <div class="pix-qrcode" *ngIf="pixDados()?.qrCodeBase64">
      <img [src]="'data:image/png;base64,' + pixDados()?.qrCodeBase64" alt="QR Code PIX" />
    </div>

    <div class="pix-info" *ngIf="pixDados()">
      <p><strong>Empresa:</strong> {{ pixDados()?.empresa }}</p>
      <p><strong>CNPJ:</strong> {{ pixDados()?.cnpj }}</p>
      <p><strong>Valor:</strong> {{ formatPreco(pixDados()?.valor) }}</p>
      <p><strong>Email:</strong> {{ pixDados()?.email }}</p>
      <p><strong>Envie o comprovante para </strong> (11) 96318-3437</p>
    </div>

    <div class="actions">
      <button (click)="checkoutStatus.set('success'); passo.set(8)">OK</button>
    </div>
  </section>

  <!-- Passo 8: Finalização -->
  <section *ngIf="isAtivo(8)" class="card">
    <ng-container [ngSwitch]="checkoutStatus()">
      <div *ngSwitchCase="'success'">
        <h3>🎉 Assinatura realizada com sucesso!</h3>
        <p>Obrigado, {{ nome() }}. Enviaremos um email de boas vindas para {{ email() }}.</p>
      </div>
      <div *ngSwitchCase="'error'">
        <h3>⚠️ Ocorreu um erro na assinatura</h3>
        <p>Tente novamente ou entre em contato com o suporte.</p>
      </div>
      <div *ngSwitchDefault>
        <h3>Finalização</h3>
        <p>Nenhum status de checkout recebido.</p>
      </div>
    </ng-container>
    <div class="actions">
      <button (click)="passo.set(1); checkoutStatus.set(null)">Voltar ao início</button>
    </div>
  </section>
  <a class="whatsapp-fab" href="https://wa.me/5511963183437" target="_blank" rel="noopener" aria-label="Falar no WhatsApp">
    <svg class="whatsapp-fab__icon" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M19.11 17.36c-.28-.14-1.66-.82-1.92-.92-.26-.1-.45-.14-.64.14-.19.28-.74.92-.91 1.11-.17.19-.34.21-.62.07-.28-.14-1.19-.44-2.27-1.41-.84-.75-1.41-1.68-1.58-1.96-.17-.28-.02-.43.13-.57.13-.13.28-.34.42-.51.14-.17.19-.28.28-.47.1-.19.05-.35-.02-.5-.07-.14-.64-1.55-.88-2.12-.23-.56-.47-.49-.64-.49-.17 0-.35-.02-.54-.02-.19 0-.5.07-.76.35-.26.28-1 1-1 2.43 0 1.43 1.03 2.8 1.17 2.99.14.19 2.03 3.1 4.9 4.34.69.3 1.23.48 1.65.61.69.22 1.31.19 1.81.12.55-.08 1.66-.68 1.9-1.34.23-.66.23-1.23.16-1.34-.07-.12-.26-.19-.54-.33zM16.02 27.5h-.01c-1.97 0-3.9-.51-5.6-1.47l-.4-.24-4.15 1.09 1.11-4.05-.26-.42a11.47 11.47 0 01-1.74-6.03c0-6.36 5.19-11.54 11.57-11.54 3.09 0 6 .12 8.17 3.29 2.17 3.17 2.7 4.69 2.7 7.78 0 6.36-4.97 11.55-11.39 11.55zm9.74-21.3A13.43 13.43 0 0016 2.67C8.73 2.67 2.8 8.6 2.8 15.87c0 2.34.61 4.63 1.78 6.64L2.67 29.33l6.98-1.84a13.21 13.21 0 006.37 1.63h.01c7.26 0 13.19-5.93 13.19-13.2a13.1 13.1 0 00-3.87-9.72z"/>
    </svg>
  </a>
</div>
